export default __webpack_public_path__ + "static/2021-homepage-video-optimized-2-1-5651e3827d33589122f21ceb64541473.mp4";